import React, { useEffect, useState } from "react";
import { Row, Col, Descriptions, Form, Input, Modal, notification, Select, Card, Divider } from "antd";
import { ExclamationCircleOutlined, CloudUploadOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";

import api from "../../../services/api";
import { formatarCpfCnpj, HasValue, novaAbaNavegador } from "../../../services/funcoes";
import { FormatNumber } from "../../../ValueObjects";
import SelectPaginacao from "../../selects/selectPaginacao";

export default function ModalDavParaDfe({ dadosNota, exibirModalDavParaDfe, fecharModalDavParaDfe, titleModal, textoBotao }) {
    const [form] = Form.useForm();
    const [carregando, setCarregando] = useState(false);


    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                form.resetFields();
                fecharModalDavParaDfe();
            }
        });
    };

    const gerarNfe = async () => {
        let dados = {};
        dados.ser_id = form.getFieldValue().ser_id;
        dados.ntf_id = dadosNota.ntf_id;

        setCarregando(true);

        try {
            const retornoNF = await api.put(`NotaFiscal/GerarNotaFiscalDAV`, dados);
            if (retornoNF.status === 200) {
                if (retornoNF.data.ntf_status === 1 && !!retornoNF.data.ntf_chavenfe) {
                    notification.success({ message: 'Sucesso', description: `NF-e Autorizada com sucesso!` });
                    novaAbaNavegador(`Danfe/GerarDanfe?chaveNFe=${retornoNF.data.ntf_chavenfe}`);
                    let formaPagItegrado = retornoNF.data.notafiscalformapgtos.filter((item) => (HasValue(item.imp_id)))
                    if (formaPagItegrado.length > 0) {
                        novaAbaNavegador(`Danfe/GerarComprovantePagamentoViaLoja?IdNotaFiscal=${retornoNF.data.ntf_id}`);
                    }
                } else {
                    notification.error({ description: 'Não foi possível Autorizar nota fiscal! ' + retornoNF.data.ntf_xmotivo, message: `Aviso` });
                }
            } else {
                notification.error({ description: 'Não foi possível Autorizar nota fiscal!', message: `Aviso` });
            }
        }
        catch (erro) {
            if (!!erro.response && !!erro.response.data) {
                notification.error({ description: erro.response.data, message: `Aviso` });
            } else {
                notification.error({ description: 'Não foi possível Autorizar nota fiscal!', message: `Aviso` });
            }
            setCarregando(false);
        }
        finally {
            setCarregando(false);
            form.resetFields();
            fecharModalDavParaDfe();
        }
        console.log(dadosNota)
    };
    return (
        <Modal centered
            title={titleModal}
            open={exibirModalDavParaDfe}
            onCancel={onCloseModal}
            onOk={gerarNfe}
            confirmLoading={carregando}
            okText={
                <>
                    <CloudUploadOutlined /> Gerar NF-e
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
            destroyOnClose
        >
            <Form layout="vertical" form={form}>
                <Card title="Informações da Nota" size="small" bordered={false}>
                    <Descriptions size="small">
                        <Descriptions.Item label={`Chave da `}>
                            <b> {dadosNota.ntf_chavenfe} </b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Destinatário">
                            <b> {dadosNota.ntf_nomedest ?? dadosNota.cta_razaosocial}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="CPF/CNPJ">
                            <b> {formatarCpfCnpj(dadosNota.ntf_cnpjcpfdest)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Nº da Nota">
                            <b>{dadosNota.ntf_numero}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="Emitida em">
                            <b>{moment(dadosNota.ntf_dataemissao).format('DD/MM/YYYY')}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Valor Total da Nota (R$)">
                            <b> {FormatNumber(dadosNota.valor_total, true)} </b>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                <Divider />

                <Card title="Configuração da NF-e" size="small" bordered={false}>
                    <Form.Item
                        label="Série Fiscal"
                        name="ser_id"
                        rules={[{ required: true, message: 'Selecione uma série fiscal' }]}
                    >
                        <SelectPaginacao
                            url="SerieFiscal/Listar?CodigoModeloDocFiscal=55&EmitenteDocumento=0"
                            placeholder="Informe a Série"
                            form={form}
                            nameLabel="ser_serie"
                            nameValue="ser_id"
                            selecionarRegUnico="ser_id"
                            allowClear
                            conteudo={pc => (
                                (<Select.Option label={pc.ser_serie} value={pc.ser_id} key={pc.key}>{pc.ser_serie} <br />
                                </Select.Option>)
                            )}
                        />
                    </Form.Item>
                </Card>
            </Form >
        </Modal >
    );
}